import { render, staticRenderFns } from "./ratingOfParticipant.vue?vue&type=template&id=7c0a2636&scoped=true&"
import script from "./ratingOfParticipant.vue?vue&type=script&lang=js&"
export * from "./ratingOfParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0a2636",
  null
  
)

export default component.exports